import { NgModule } from "@angular/core";
import { MatMenuModule } from "@angular/material/menu";

// Modules
import { ArticleModule } from "./article/article.module";
import { BackgroundDirective } from "./background/background.directive";
import { BadgeModule } from "./badge/badge.module";
import { ButtonModule } from "./button/button.module";
import { IcCalendarModule } from "./calendar/calendar.module";
import { CardModule } from "./card/card.module";
import { ContainerModule } from "./container/container.module";
import { DateFilterModule } from "./date-filter/date-filter.module";
import { UIDirectivesModule } from "./directives";
import { EmptyStateModule } from "./empty-state/empty-state.module";
import { FigureModule } from "./figure/figure.module";
import { FilterModule } from "./filter/filter.module";
import { GraphModule } from "./graph/graph.module";
import { IconModule } from "./icon/icon.module";
import { ImageModule } from "./image/image.module";
import { IndicatorModule } from "./indicator/indicator.module";
import { InputModule } from "./input/input.module";
import { LoadingIndicatorModule } from "./loading-indicator/loading-indicator.module";
import { MenuDropdownModule } from "./menu-dropdown/menu-dropdown.module";
import { ModalModule } from "./modal";
import { RootComponent } from "./root";
import { SearchModule } from "./search/search.module";
import { SearchListModule } from "./search-list/search-list.module";
import { ToastModule } from "./snackbar";
import { TableModule } from "./table/table.module";
import { TextModule } from "./text/text.module";
import { TimelineModule } from "./timeline/timeline.module";
import { TimerModule } from "./timer/timer.module";
import { TitleBarModule } from "./title-bar/title-bar.module";
import { TreeViewModule } from "./tree-view/tree-view.module";

// Components

const modules = [
	ArticleModule,
	BadgeModule,
	ButtonModule,
	CardModule,
	ContainerModule,
	DateFilterModule,
	EmptyStateModule,
	FigureModule,
	FilterModule,
	GraphModule,
	IcCalendarModule,
	IconModule,
	ImageModule,
	IndicatorModule,
	InputModule,
	LoadingIndicatorModule,
	MatMenuModule,
	MenuDropdownModule,
	ModalModule,
	RootComponent,
	SearchListModule,
	SearchModule,
	TableModule,
	TextModule,
	TimelineModule,
	TimerModule,
	TitleBarModule,
	ToastModule,
	TreeViewModule,
	UIDirectivesModule,
];

const declarations = [BackgroundDirective];

@NgModule({
	imports: [...modules],
	declarations: [...declarations],
	exports: [...modules, ...declarations],
})
export class UIModule {}
